export const environment = {
  production: false,
  limitBandwidthUser: 3.5,
  limitBandwidthSystem: 6.0,
  supportEmail: 'support@medinbox.com',
  apiUrl: 'https://api.precall.dev.aws.medinbox.link',
  webSocketUrl: 'wss://api.precall.dev.aws.medinbox.link',
};
